import { render, staticRenderFns } from "./ScoreBadge.vue?vue&type=template&id=8cbf71a8"
import script from "./ScoreBadge.vue?vue&type=script&lang=js"
export * from "./ScoreBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports